<div class="form border-radius">
  <div class="form__block">
    <app-change-password />
  </div>
</div>
